<template>
	<div>
		<Form :label-width="80">
			<FormItem label="筛选类型">
				<RadioGroup v-model="selectDay" @on-change="search">
					<Radio label="7" border><span>近七天</span></Radio>
					<Radio label="15" border><span>近15天</span></Radio>
					<Radio label="30" border><span>近30天</span></Radio>
				</RadioGroup>
			</FormItem>
			<FormItem label="类型">
				<Select v-model="cidType" style="width:150px;" clearable placeholder="类型" >
					<Option v-for="item in cidTypeList" :value="item.id" :key="item.id">{{ item.type }}</Option>
				</Select>
				<Select v-model="account"  style="width: 100px;margin-left: 10px;width: 150px;" filterable multiple
					clearable placeholder="请选择账户">
					<Option v-for="item in accountList" :value="item.account_id" :key="item.account_id">
						{{ item.account_name}}
					</Option>
				</Select>
				<el-Button type="primary" @click="search" style="margin-left: 10px;">搜索</el-Button>
				<el-Button @click="initSearch" style="margin-left: 10px;">重置</el-Button>
			</FormItem>
		</Form>
		<!--Tabs value="name1" @on-click="tabClick">
			<TabPane label="数量指标" name="name1"></TabPane>
			<TabPane label="成本指标" name="name2"></TabPane>
			<TabPane label="优质率指标" name="name3"></TabPane>
		</Tabs-->
		<div style="width: 100% ;margin-top: 20px;">
			<Table :columns="columns" :data="tableData" border>
				<template slot-scope="{ row,index }" slot="date">
					<span style="color: #2d8cf0;cursor: pointer;" @click="openDayReport(row.date)">{{row.date}}</span>
				</template>
				<template slot-scope="{ row,index }" v-for="item in cityList" :slot="item.city">
					<div
						v-if="(row[item.cityAverageCost] != 0 &&row[item.cityAverageCost] != undefined)  && (row[item.cityAccountConvert] != 0 && row[item.cityAccountConvert] != undefined)">
						<div>
							<!--span
								style="color: #ff007f;">{{row[item.cityAverageCost]?row[item.cityAverageCost]:0}}</span-->
								<!--span
								style="color: #55aaff;font-weight: bold;">{{row[item.cityAccountConvert]?row[item.cityAccountConvert]:0}}</span-->
								<span
								style="color: #ffaa7f;font-weight: bold;">{{row[item.city+'优质率']}}</span>
						</div>
						<!--div :class="{'second': (row[item.city] >= row[item.cityDemand])}">
							<span>{{row[item.city]?row[item.city]:0}}/{{row[item.cityDemand]?row[item.cityDemand]:0}}</span>
						</div>
						<div >
							<span>{{row[item.city+'优质率']}}</span>
						</div-->
					</div>
					<div v-else>
						<Icon type="md-close" style="color: red;" size="30" />
					</div>
				</template>
			</Table>
		</div>
		<Modal v-model="dayDemandReportModal" width="1000" title="单日情况">
			<DemandReportByDay :date="date"></DemandReportByDay>
		</Modal>
	</div>
</template>
<script>
	import DemandReportByDay from './components/DemandReportByDay.vue'
	import {
		mapGetters
	} from "vuex";
	import {
		getAdvCity,
	} from "../../api/runSet";
	import {
		getCidTypeList,
		getDamandDataList,
		getCostTrends,
		getAllAccountList
	} from "../../api/advManage";

	export default {
		name: "demand_data",
		components: {
			DemandReportByDay
		},
		props: ['clickTabValue'],
		data() {
			return {
				modal: false,
				dayDemandReportModal: false,
				name: '',
				timePeriod: '7',
				selectDay: '15',
				cidType: '',
				date: '',
				tabNum: 1,
				timePeriodDate: [],
				accountList:[],
				account:[
  "1778998714109005",
  "1762762065367047",
  "1786135340534019",
  "1765017201457166",
  "1771289205769293",
  "1778998713460740",
  "1780629080763402",
  "1787506875185225",
  "1787506822081610",
  "1793288742132748",
  "1787506827459593",
  "1771289205175309"
],
				datas: [],
				columns: [{
					title: '日期',
					slot: 'date',
					"align": 'center',
				}],
				cityList: [],
				tableData: [],
				defaultColumns: [{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "总数",
						"slot": "all",
						"align": 'center',
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.account = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				//拼接表头
				console.log(that.cityList);
				for (let i = 0; i < that.cityList.length; i++) {
					var data1 = {};
					data1.title = that.cityList[i].city;
					data1.slot = that.cityList[i].city;
					data1.align = "center";
					that.columns.splice(i + 1, 0, data1); //从数组的第二项开始插入
				}
				res = await getAllAccountList(that, data);
				that.accountList = res.data.list;

				this.getList();
			},
			tabClick(e) {
				if (e == "name1") {
					this.tabNum = 1;
				} else if (e == "name2") {
					this.tabNum = 2;
				} else if (e == "name3") {
					this.tabNum = 3;
				}
			},
			openDayReport(date) {
				let that = this;
				that.date = date;
				that.dayDemandReportModal = true;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getCostTrends(that, data);
				that.tableData = res.data.list;
				console.log(that.tableData)
			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #0055ff;
	}

	/deep/ .ivu-table .table-black-row td {
		color: #ffff00;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.first {
		background-color: #d47e83;

		color: #fff;

	}

	.check-threeplus-false {
		color: cornflowerblue;
	}

	.check-threeplus-true {
		color: #fff;
	}

	.second {

		background-color: #277dd3;

		color: #fff;

	}
</style>